import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/BackDrop.tsx",
    _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { LinearProgress } from '@gmini/ui-kit/lib/LinearProgress';
import { Backdrop as BackdropInit } from '@gmini/ui-kit/lib/Backdrop';
export var Backdrop = styled(BackdropInit)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    position: absolute;\n    z-index: 2;\n    align-items: flex-start;\n    background-color: rgba(255, 255, 255, 0.7);\n  }\n"])));
export var ProgressBar = styled(LinearProgress)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));